import styled from 'styled-components';

export const ProfileWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
  `

export const Image = styled.img`
    padding-bottom: 2rem;
    width: 60%;
  `

export const SocialMediaIcons = styled.div`
    display: inline;
  `

export const IconLink = styled.a`
    font-size: 1.7rem;
    & > * {
      margin-right: 0.5rem;
    }
  `

export const TextWrapper = styled.div``
